import React, { useState, useCallback } from 'react';
import { SprayProduct } from '../../services/sprayService';
import SprayProductList from './SprayProductList';
import SprayProductForm from './SprayProductForm';

const SprayProductsPage: React.FC = () => {
  const [showForm, setShowForm] = useState(false);
  const [editProduct, setEditProduct] = useState<SprayProduct | undefined>();
  const [refreshKey, setRefreshKey] = useState(0);

  const handleAdd = useCallback(() => { setEditProduct(undefined); setShowForm(true); }, []);
  const handleEdit = useCallback((product: SprayProduct) => { setEditProduct(product); setShowForm(true); }, []);
  const handleCancel = useCallback(() => { setShowForm(false); setEditProduct(undefined); }, []);
  const handleSave = useCallback((_product: SprayProduct) => {
    setShowForm(false);
    setEditProduct(undefined);
    setRefreshKey(k => k + 1);
  }, []);

  return (
    <div>
      {showForm ? (
        <SprayProductForm product={editProduct} onSave={handleSave} onCancel={handleCancel} />
      ) : (
        <SprayProductList key={refreshKey} onAdd={handleAdd} onEditProduct={handleEdit} />
      )}
    </div>
  );
};

export default SprayProductsPage;
